require('../../../iconfont.config');
const bootHelper = require('./bootHelper');

bootHelper.boot(() => require.context('app', false), module.hot);
